import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { text }
  } = theme;

  return {
    wrapVideoPlayer: {
      width: "100%",
      aspectRatio: "7/4",
      position: "relative",
      cursor: "pointer"
    },
    actionButton: {
      width: "20%",
      height: "25%",
      top: "37%",
      left: "40%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      opacity: 1,
      transition: "opacity 1s",
      zIndex: 1,
      "&.hidden": {
        opacity: 0
      },
      "&.none": {
        display: "none"
      }
    },
    actionButtonIcon: {
      width: "100%",
      height: "100%",
      color: "#fff"
    },
    loader: {
      aspectRatio: "7/4"
    },
    noContent: {
      aspectRatio: "7/4",
      color: text.secondary
    }
  };
});
